import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import CheckIcon from '@mui/icons-material/Check';
import { useDispatch, useSelector } from 'react-redux';
import { noDataFoundStyles, useStyles } from '../../ocplcDashboard/ocplcHelpers';
import { MATERIAL_AVAILABILITY, OCPLC_DROPDOWN, ROLE_DETAILS_MAP, MATERIAL, FACTORY_SERVICES, SERVICE, DEFAULT_LOC, LOC_AVAILABILITY, VERSION_0002, VERSION_0003, TOF_PROGRAM_MANAGEMENT, LOC_CHOICE_ID, LOC_MAPPING, OCPLC_ADMIN, OCPLC_READ_ONLY, OCPLC_REGIONAL, ROLE_NAME_FOR_KE, ROLE_DETAILS_MAP_TOF, REGION_WW } from 'constants/ocplcConstants';
import {   CATEGORY_TYPES, filterDetails, findSelectedRole, getFilteredRegions, getPlcRoles, getVersion, isPLCAdmin, LOCALIZATION_TABLES, PARAMETER_TABLES, tableDTMap } from 'pages/Utils/OcplcUtil';
import PlcEditDashboard from 'pages/OcplcEditDashboard/PlcEditDashboard';
import { categoryFilter, clearOcplcFilters, filterOcplcDashboard, filterOcplcKmat, filterOcplcKmatforPG, loadCountForDT, ocplcRegionDropDown, ocplcTableData, productGroupDropDown } from 'actions/ocplcAction';
import Box from '@mui/material/Box';
import UploadDownloadDataTransIcons from '../OcplcWorkSpaceButtons/UploadDownloadDatatransIcons';
import CloseIcon from '@mui/icons-material/Close';
import NotFound from 'pages/NotFound';
import { TABLE_TYPES } from '../TableDataConfig';
import { IconButton, OutlinedInput } from '@mui/material';
import { snackBar } from 'actions/modelActions';
import OCPLCConfigurationScreen from '../OcplcWorkSpaceButtons/OCPLCConfigurationScreen';
import { getFromLocalStorage, SELECTED_ROW } from 'utils/localStorageUtil';


const OcplcEditPage = ({ auth }) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const { email, ocplcRole, roles } = auth;
    const { type } = useParams();
    const selectedRow = getFromLocalStorage(SELECTED_ROW);
    const kmatId = selectedRow?.kmatId;
    const productGroup = selectedRow?.productGroup;
    const productLineID = selectedRow?.productLineID;
    const version = getVersion(type);
    const location = useLocation();
    const navigate = useNavigate();
    
    const tableData = useSelector(state => state.ocplc.tableData);
    const filterKmats = useSelector(state => state.ocplc.filterKmats);
    const filterOcplcKmatForPG = useSelector(state => state.ocplc.filterOcplcKmatForPG);
    const regionDropdown = useSelector(state => state.ocplc.regionDropdown);
    const categories = useSelector(state => state.ocplc.categoryFilter);
    const productGroups = useSelector(state => state.ocplc.productGroupDropdown);
    const isParametersMode = location.pathname.includes('parameters');
    const isLocalizationMode = location.pathname.includes('localization');

    const selectedDefaultRole = findSelectedRole(roles, ocplcRole);
    const [assignedRole, setAssignedRole] = useState(selectedDefaultRole?.name);
    const [selectedVersion, setSelectedVersion] = useState(VERSION_0003);
    const [selectedRegion, setSelectedRegion] = useState( isParametersMode ? ROLE_DETAILS_MAP_TOF[selectedDefaultRole?.name]?.region : ROLE_DETAILS_MAP[selectedDefaultRole?.name]?.region);
    const [selectedTable, setSelectedTable] = useState(
        isParametersMode
            ? PARAMETER_TABLES[0]
            : isLocalizationMode
                ? LOCALIZATION_TABLES[0]
                : ROLE_DETAILS_MAP[selectedDefaultRole?.name]?.table
    );
    const [selectedCategory, setSelectedCategory] = useState('PM');
    const [selectedProductGroup, setSelectedProductGroup] = useState(isLocalizationMode ? 'DT' : '');
    const [selectKmat, setSelectedKmat] = useState(kmatId);
    const [selectLocKmat, setSelectLocKmat] = useState('');
    const [checkedRows, setCheckedRows] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const plcRoles = getPlcRoles(roles);
    const ocplcAdmin = isPLCAdmin(assignedRole);
    const isAdminRegionalKE = [OCPLC_ADMIN,OCPLC_REGIONAL,OCPLC_READ_ONLY,ROLE_NAME_FOR_KE].includes(assignedRole)


    const tableOptions = isParametersMode
        ? PARAMETER_TABLES.map(subCategory => ({ subCategory }))
        : isLocalizationMode
            ? LOCALIZATION_TABLES.map(subCategory => ({ subCategory }))
            : tableData;
     
    const currentKmatFilter = 
    (selectedTable === LOC_AVAILABILITY || selectedTable === DEFAULT_LOC)
        ? filterOcplcKmatForPG
        : filterKmats;
        

    useEffect(() => {
        dispatch(ocplcTableData())
        dispatch(ocplcRegionDropDown(ocplcRole));
        if (isLocalizationMode) {
            dispatch(filterOcplcKmatforPG(selectedProductGroup, email));
            dispatch(productGroupDropDown());
        }
        if (!isParametersMode && !isLocalizationMode) {
            dispatch(filterOcplcKmat(productLineID));
        }
        if( selectedTable === TOF_PROGRAM_MANAGEMENT && isAdminRegionalKE){
            setSelectedRegion("AP")
        }
    }, [])

useEffect(() => {
    const source = localStorage.getItem('ocplc_source');

    // Exclude for parameters and localization modes
    if (!isParametersMode && !isLocalizationMode && source && type !== source) {
        navigate(
            `/ocplc/${source}`,
            { replace: true, state: { source } }
        );
        dispatch(snackBar(true, 'You are not allowed to modify the URL', 'warning'));
    }
}, [navigate, type, kmatId, productGroup, productLineID, isParametersMode, isLocalizationMode]);


    useEffect(() => {
    if (selectedTable !== 'OCPLC Configuration') {
        const dtType = tableDTMap[selectedTable];
        dispatch(loadCountForDT(dtType));
    }
    }, [selectedTable]);


  const handleTableChange = (e) => {
    const value = e.target.value;
    setSelectedTable(value);
    setSelectedRegion("WW");
    setSelectedKmat(kmatId);
    setCheckedRows([]);
    setSelectedIds([]);
    dispatch(clearOcplcFilters());
    if( value === TOF_PROGRAM_MANAGEMENT){
        setSelectedRegion("AP")
    }
    if (isLocalizationMode) {
        setSelectedProductGroup('DT');
        setSelectLocKmat('')
        dispatch(filterOcplcKmatforPG('DT', email));
    }
    if (value === DEFAULT_LOC || value === LOC_AVAILABILITY || value === TOF_PROGRAM_MANAGEMENT) {
        const roleRegionMap = {
            'OCPLC KE - AP': 'AP',
            'OCPLC KE - EU': 'EU',
            'OCPLC KE - LA': 'LA',
            'OCPLC KE - NA': 'NA'
        };
        const region = roleRegionMap[assignedRole] || (value === DEFAULT_LOC || value === TOF_PROGRAM_MANAGEMENT ? 'AP' : 'WW');
        setSelectedRegion(region);
        return;
    }
    if(value === MATERIAL_AVAILABILITY){
        setSelectedCategory("PM")
    }
};

    const handleVersionSelection = (e) => {
        const value = e.target.value;
        setSelectedVersion(value);
        dispatch(clearOcplcFilters());
    };

    const handleRolesSelection = (e) => {
        const selectedRole = e.target.value;
        setAssignedRole(selectedRole);
        setSelectedKmat(kmatId);
        setCheckedRows([]);
        setSelectedIds([]);
        dispatch(clearOcplcFilters());
        const role = plcRoles.find(role => role.name === selectedRole);
        if (selectedTable === TOF_PROGRAM_MANAGEMENT) {
            dispatch(ocplcRegionDropDown(role?.id));
        if (selectedRole === 'OCPLC KE - AP') {
            setSelectedRegion("AP");
        } else if (selectedRole === 'OCPLC KE - EU') {
            setSelectedRegion("EU");
        } else if (selectedRole === 'OCPLC KE - LA') {
            setSelectedRegion("LA");
        } else if (selectedRole === 'OCPLC KE - NA') {
            setSelectedRegion("NA");
        } else {
            setSelectedRegion("AP");
        }
        return;
    }
    if (selectedTable === DEFAULT_LOC) {
            dispatch(ocplcRegionDropDown(role?.id));
        if (selectedRole === 'OCPLC KE - EU') {
            setSelectedRegion("EU");
        } else if (selectedRole === 'OCPLC KE - LA') {
            setSelectedRegion("LA");
        } else if (selectedRole === 'OCPLC KE - NA') {
            setSelectedRegion("NA");
        } else {
            setSelectedRegion("AP");
        }
        return;
    }

        if (selectedRole) {
            const role = plcRoles.find(role => role.name === selectedRole);
            if (role) {
                setSelectedRegion(ROLE_DETAILS_MAP[selectedRole]?.region);
                // Only change table if NOT in parameters or localization mode
                if (!isParametersMode && !isLocalizationMode) {
                    setSelectedTable(ROLE_DETAILS_MAP[selectedRole]?.table);
                }
                dispatch(ocplcRegionDropDown(role?.id));
            }
            if (
                role &&
                ROLE_DETAILS_MAP[selectedRole]?.table === MATERIAL_AVAILABILITY &&
                !isParametersMode &&
                !isLocalizationMode
            ) {
                setSelectedCategory('PM');
            }
        }
        
    if(selectedTable === LOC_CHOICE_ID || selectedTable === LOC_MAPPING){
        setSelectedRegion('WW')
    }
    };
 
    const handleProductGroupSelection = (e) => {
        const value = e.target.value;
        setSelectedProductGroup(value);
        if (isLocalizationMode) {
            dispatch(filterOcplcKmatforPG(value, email));
            setSelectLocKmat("")
        }
    }

    const handleKmatSelection = (e) => {
        if (isLocalizationMode) {
            setSelectLocKmat( e.target.value);
        } else {
            setSelectedKmat(e.target.value);
        }
    };

    const handleClearKmat = () => {
        if (isLocalizationMode) {
            setSelectLocKmat('');
        } else {
            setSelectedKmat('');
        }
    };


    const handleRegionSelection = (e) => {
        const value = e.target.value
        setSelectedRegion(value)
        dispatch(clearOcplcFilters());
    }
    const handleCategorysSelection = (e) => {
        setSelectedCategory(e.target.value)
        dispatch(clearOcplcFilters());
    }

    const details = [
        { label: "Table Name", value: selectedTable, color: "#B0B0B0" },
        ...(selectedTable === 'OCPLC Configuration'
            ? []
            : [
                { label: "Version", value: (isParametersMode || isLocalizationMode) ? selectedVersion : version, color: "#B0B0B0" },
                { label: "Region", value: selectedRegion, color: "#B0B0B0" }
            ]
        ),
        ...(isParametersMode ? [] : [
            { label: "Product Family", value: isLocalizationMode ? selectLocKmat : selectKmat || '', color: "#B0B0B0" },
            { label: "Product Group", value: selectedProductGroup || productGroup, color: "#B0B0B0" }
        ]),
        ...(isLocalizationMode || isParametersMode ? [] : [
            { label: "Status", value: "In Progress", color: "#1976D2" }
        ]),
    ];


    const filteredDetails = filterDetails(details, isLocalizationMode ? selectLocKmat : selectKmat, isParametersMode || isLocalizationMode ? selectedVersion : version, selectedTable);
    const filteredRegionDropdown = getFilteredRegions(regionDropdown,selectedTable);

    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: "space-between" }}>
                <div className={classes.divContainer}>
                    {OCPLC_DROPDOWN.map((label, idx) => {
                        if (
                            label === "Tab Category" &&
                            selectedTable !== MATERIAL_AVAILABILITY
                        ) {
                            return null;
                        }
                        if (label === "Version") {
                            if (!(isParametersMode || isLocalizationMode) || selectedTable === 'OCPLC Configuration')
                            return null;
                            return (
                                <div key={idx} className={classes.headerChildren}>
                                    <FormControl fullWidth>
                                        <InputLabel
                                            sx={{ marginTop: "8px !important" }}
                                            shrink={true}
                                        >
                                            Version
                                        </InputLabel>
                                        <Select
                                            value={selectedVersion}
                                            onChange={handleVersionSelection}
                                            renderValue={(selected) => selected}
                                            className={classes.regionSelect}
                                            MenuProps={{
                                                PaperProps: { className: classes.paperProps },
                                            }}
                                            input={<OutlinedInput />}
                                        >
                                            <MenuItem value={VERSION_0002}>
                                                0002
                                                {selectedVersion === VERSION_0002 && (
                                                    <CheckIcon className={classes.checkIcon} />
                                                )}
                                            </MenuItem>
                                            <MenuItem value={VERSION_0003}>
                                                0003
                                                {selectedVersion === VERSION_0003 && (
                                                    <CheckIcon className={classes.checkIcon} />
                                                )}
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            );
                        }
                        if (
                            isParametersMode &&
                            !["Role", "Table", "Region", "Version"].includes(label)
                        ) {
                            return null;
                        }
                        if (label === 'Product Group' && selectedTable !== LOC_AVAILABILITY && selectedTable !== DEFAULT_LOC) {
                            return null;
                        }
                         if (label === 'Region' && selectedTable === 'OCPLC Configuration') {
                            return null;
                        }
                                            return (
                            <div key={idx} className={classes.headerChildren}>
                                <FormControl fullWidth>
                                    <InputLabel sx={{ marginTop: "8px !important" }} shrink={true}>{label}</InputLabel>
                                    <Select
                                        key={selectedTable}
                                        value={
                                            label === 'Role' ? assignedRole
                                                : label === 'Version' ? (isParametersMode || isLocalizationMode ? selectedVersion : version)
                                                    : label === 'Table' ? selectedTable
                                                        : label === 'Region' ? selectedRegion
                                                            : label === 'Tab Category' ? CATEGORY_TYPES[selectedCategory]
                                                                : label === 'Product Group' ? selectedProductGroup
                                                                    : isLocalizationMode && label === 'Product Family' ? selectLocKmat
                                                                        : selectKmat
                                        }
                                        onChange={
                                            label === 'Role' ? handleRolesSelection
                                                : label === 'Version' ? handleVersionSelection
                                                    : label === 'Table' ? handleTableChange
                                                        : label === 'Region' ? handleRegionSelection
                                                            : label === 'Tab Category' ? handleCategorysSelection
                                                                : label === 'Product Group' ? handleProductGroupSelection
                                                                    : handleKmatSelection
                                        }
                                        renderValue={(selected) => selected}
                                        className={`${classes.regionSelect} ${((label === 'Product Family' && (isLocalizationMode ? selectLocKmat : selectKmat) && !([TABLE_TYPES.MATERIAL, TABLE_TYPES.FACTORY].includes(selectedTable))) ||
                                            (label === 'Tab Category' && selectedCategory)) ? classes.miuiIcon : ""}`}
                                        disabled={label === 'Role' && plcRoles.length === 1}
                                        MenuProps={{ PaperProps: { className: classes.paperProps } }}
                                        input={
                                            <OutlinedInput
                                                endAdornment={
                                                    <div className="end-adornment">
                                                        {((label === 'Product Family' && (isLocalizationMode ? selectLocKmat : selectKmat) && !([TABLE_TYPES.MATERIAL, TABLE_TYPES.FACTORY].includes(selectedTable))) ||
                                                            (label === 'Tab Category' && selectedCategory)) ? (
                                                            <IconButton
                                                                aria-label="clear selection"
                                                                size="small"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    if (label === 'Product Family') {
                                                                        handleClearKmat();
                                                                    } else {
                                                                        setSelectedCategory('');
                                                                    }
                                                                }}
                                                            >
                                                                <CloseIcon fontSize="small" />
                                                            </IconButton>
                                                        ) : null}
                                                    </div>
                                                }
                                            />
                                        }
                                    >
                                        {label === 'Role' && plcRoles?.map(role => (
                                            <MenuItem
                                                key={role.id}
                                                value={role.name}
                                                disabled={selectedTable === 'OCPLC Configuration' && role.name !== OCPLC_ADMIN}
                                            >
                                                {role.name}
                                                {assignedRole === role.name && <CheckIcon className={classes.checkIcon} />}
                                            </MenuItem>
                                        ))}
                                        {label === 'Table' && tableOptions
                                            ?.filter(item =>
                                                !(isParametersMode && item.subCategory === 'OCPLC Configuration' && !ocplcAdmin)
                                            )
                                            .map((item, index) => (
                                                <MenuItem key={index} value={item.subCategory}>
                                                    {item.subCategory}
                                                    {selectedTable === item.subCategory && <CheckIcon className={classes.checkIcon} />}
                                                </MenuItem>
                                            ))}
                                        {label === 'Region' && filteredRegionDropdown?.map((region, index) => (
                                            <MenuItem key={index} value={region.code}>
                                                {region.code} | {region.name}
                                                {selectedRegion === region.code && <CheckIcon className={classes.checkIcon} />}
                                            </MenuItem>
                                        ))}
                                        {label === 'Tab Category' && categories?.map((category, index) => (
                                            <MenuItem key={index} value={category.value}>
                                                {(category.text)}
                                                {selectedCategory === category.value && <CheckIcon className={classes.checkIcon} />}
                                            </MenuItem>
                                        ))}
                                        {label === 'Product Group' && productGroups?.map((productGroup, index) => (
                                            <MenuItem key={index} value={productGroup.productGroup}>
                                                {(productGroup.productGroup)}
                                                {selectedProductGroup === productGroup.productGroup && <CheckIcon className={classes.checkIcon} />}
                                            </MenuItem>
                                        ))}
                                        {label === 'Product Family' && (
                                            currentKmatFilter &&
                                            (Object.keys(currentKmatFilter).length > 0 ? (
                                                Object.values(currentKmatFilter).map(({ kmatId }, index) => {
                                                    if (kmatId === "ALL" && selectedTable === "Model Availability") return null;
                                                    return (
                                                        <MenuItem key={kmatId || index} value={kmatId}>
                                                            {kmatId}
                                                            {(isLocalizationMode ? selectLocKmat === kmatId : selectKmat === kmatId) && <CheckIcon className={classes.checkIcon} />}
                                                        </MenuItem>
                                                    );
                                                })
                                            ) : (
                                                <MenuItem disabled>No data found</MenuItem>
                                            ))
                                        )}
                                    </Select>
                                </FormControl>
                            </div>
                        );
                    })}
                </div>

                <Box sx={{ marginTop: "15px" }}>
                    <UploadDownloadDataTransIcons
                        kmatId={isLocalizationMode ? selectLocKmat : kmatId}
                        selectKmat={isLocalizationMode ? selectLocKmat : selectKmat}
                        productGroup={productGroup}
                        productLineID={productLineID}
                        tableData={tableData}
                        selectedTable={selectedTable}
                        title={"ocplcEdit"}
                        version={isParametersMode || isLocalizationMode ? selectedVersion : version}
                        userRole={ocplcRole}
                        region={selectedRegion}
                        assignedRole={assignedRole}
                        checkedRows={checkedRows}
                        setCheckedRows={setCheckedRows}
                        userEmail={email}
                        ocplcAdmin={ocplcAdmin}
                        filterKmats={filterKmats}
                        selectedCategory={selectedCategory}
                        selectedProductGroup={selectedProductGroup}
                        selectedIds={selectedIds}
                        setSelectedIds={setSelectedIds}
                    />
                </Box>
            </Box>

            <div style={{ marginBottom: "15px" }}>
                {selectedTable && filteredDetails.map((detail, index) => (
                    <span key={index}>
                        <span style={{ color: "#333" }}>{detail.label}:</span> &nbsp;
                        <span style={{ color: detail.color }}>{detail.value}</span>
                        {index < filteredDetails.length - 1 && " | "}
                    </span>
                ))}
            </div>

            {selectedTable === 'OCPLC Configuration' ? (
                <OCPLCConfigurationScreen
                    assignedRole={assignedRole}
                    whoChanged={email}
                    version={isParametersMode || isLocalizationMode ? selectedVersion : version}
                />
            ) : (
                (Object.values(TABLE_TYPES).includes(selectedTable) ||
                    (isParametersMode && PARAMETER_TABLES.includes(selectedTable)) ||
                    (isLocalizationMode && LOCALIZATION_TABLES.includes(selectedTable))
                ) ? (
                    <PlcEditDashboard
                        assignedRole={assignedRole}
                        kmatId={isLocalizationMode ? selectLocKmat : selectKmat}
                        version={isParametersMode || isLocalizationMode ? selectedVersion : version}
                        productGroup={productGroup || selectedProductGroup}
                        region={selectedRegion}
                        regionDropdown={filteredRegionDropdown}
                        userRole={ocplcRole}
                        userEmail={email}
                        productLineID={productLineID}
                        checkedRows={checkedRows}
                        setCheckedRows={setCheckedRows}
                        selectedIds={selectedIds}
                        setSelectedIds={setSelectedIds}
                        ocplcAdmin={ocplcAdmin}
                        selectedTable={selectedTable}
                        selectedCategory={selectedCategory}
                        filterKmats={filterKmats}
                        categories={categories}
                        selectedProductGroup={selectedProductGroup}
                        filterOcplcKmatForPG={filterOcplcKmatForPG}
                    />
                ) : (
                    <div style={noDataFoundStyles}>No Data Found</div>
                )
            )}
        </>
    );
};

export default OcplcEditPage;